export default function subjectSelectionValidater(selectedIds) {
  'use strict';

  const errors = [];

  const hash = {};
  let tmp1, tmp2;
  selectedIds.forEach(id => {
    hash[id] = true;
  });

  if (hash['411'] && hash['412']) errors.push('地理歴史のうち「世界史A」「世界史B」はどちらか一方しか選択できません。');
  if (hash['421'] && hash['422']) errors.push('地理歴史のうち「日本史A」「日本史B」はどちらか一方しか選択できません。');
  if (hash['431'] && hash['432']) errors.push('地理歴史のうち「地理A」「地理B」はどちらか一方しか選択できません。');
  if (hash['452'] && hash['454']) errors.push('公民のうち「政治・経済」「倫理、政治・経済」はどちらか一方しか選択できません。');
  if (hash['451'] && hash['454']) errors.push('公民のうち「倫理」「倫理、政治・経済」はどちらか一方しか選択できません。');

  // 地理歴史の選択数
  const chiriRekishiCount = ['411', '412', '421', '422', '431', '432'].filter(id => selectedIds.includes(id)).length;

  // 公民の選択数
  const kouminCount = ['451', '452', '453', '454'].filter(id => selectedIds.includes(id)).length;

  if (chiriRekishiCount > 2) errors.push('地理歴史は2科目までしか選択できません。');
  if (kouminCount > 2) errors.push('公民は2科目までしか選択できません。');
  if (chiriRekishiCount && kouminCount && (chiriRekishiCount + kouminCount) > 2) errors.push('地理歴史・公民は合わせて最大２科目までしか選べません。');

  // 外国語の数
  const langCount = ['301', '911', '912', '913', '914'].filter(id => selectedIds.includes(id)).length;

  if (langCount > 1) errors.push('外国語は1科目までしか選択できません。');
  if (hash['311'] && !hash['301'] && langCount > 0) {
    errors.push('外国語のうち「英語（リーディング）」以外を選択した場合「英語（リスニング）」は選択できません。');
  } else if (hash['311'] && !hash['301']) {
    errors.push('外国語のうち「英語（リーディング）」を選択していない場合「英語（リスニング）」は選択できません。');
  }

  // 理科1の選択数
  const rika1Count = ['512', '522', '532', '542'].filter(id => selectedIds.includes(id)).length;

  // 理科2の選択数
  const rika2Count = ['513', '523', '533', '543'].filter(id => selectedIds.includes(id)).length;

  if (rika1Count > 2) errors.push('理科1は2科目までしか選択できません。');
  if (rika2Count > 2) errors.push('理科2は2科目までしか選択できません。');

  if (rika1Count && rika2Count) {
    if (rika1Count > 2 || rika2Count > 1) errors.push('理科1と理科2を選択する場合、\n理科1は2科目、理科2は1科目までしか選択できません。');
  }

  // 数学1の選択数
  const sugaku1Count = ['221', '222'].filter(id => selectedIds.includes(id)).length;

  // 数学2の選択数
  const sugaku2Count = ['223', '224', '901', '902', '903'].filter(id => selectedIds.includes(id)).length;

  if (sugaku1Count > 1) errors.push('数学1は1科目までしか選択できません。');
  if (sugaku2Count > 1) errors.push('数学2は1科目までしか選択できません。');

  return errors.length ? errors : null;
}



// WEBPACK FOOTER //
// ./src/js/store/modules/selfcheck/rules/subject-selection-validater.js